import { render, staticRenderFns } from "./materialChange.vue?vue&type=template&id=fd6ec4c8&scoped=true"
import script from "./materialChange.vue?vue&type=script&lang=js"
export * from "./materialChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6ec4c8",
  null
  
)

export default component.exports